module.exports = __webpack_public_path__ + "images/STACK_MIDDLE.png?v=1bce8d75aceb7a945585179c6bb7ddf1";